/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class DashboardApiConfig {
  rootUrl: string = 'http://api.nightly.somtoday.build/rest/v1';
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface DashboardApiConfigParams {
  rootUrl?: string;
}
